export function useSelectState({
  selectedValues,
  onChange,
  isMultiSelect
}: {
  selectedValues?: string[];
  onChange: (values: string[]) => void;
  isMultiSelect: boolean;
}) {
  const toggleOption = (value: string) => {
    if (isMultiSelect) {
      onChange(selectedValues?.includes(value) ? selectedValues.filter((v) => v !== value) : [...(selectedValues || []), value]);
    } else {
      onChange([value]);
    }
  };

  const clearAll = () => {
    onChange([]);
  };

  return {
    clearAll,
    toggleOption
  };
}
